import React, { FC } from 'react';
import { AvailableFeaturesUpselling, FeatureUpselling as FeatureUpsellingModule } from '@dev/ee-modules';
import { push as Push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { useMobile } from '@api/services/hooks/useMobile';
import { HomePaths, UpsellingPaths } from '@api/services/dictionaries/paths';
import { ShowDialog } from '@api/store/dialog/actions';
import { ChangeProduct } from '@api/store/products/actions';
import { ChangeProductDialog } from '../ChangeProductDialog';
import { useAvailableSwitchProduct } from '@api/services/hooks/useAvailableSwitchProduct';
import { GoogleAnalyticsEventsEnum } from '@api/services/dictionaries/GoogleAnalyticsEvents';

export const MarketingUpselling: FC = (): JSX.Element => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { billingPlanID, defaultTierID } = useAvailableSwitchProduct() || {};
    const isHomeUpselling = useRouteMatch(UpsellingPaths.MarketingHomeUpselling)?.isExact;

    // additional GA eventLabel parameter to remove after Switch Product A/B tests
    const eventLabel = isHomeUpselling ? GoogleAnalyticsEventsEnum.ApiToMarketingUpseling : GoogleAnalyticsEventsEnum.ApiToMarketingMenu;

    const breadcrumbs = isHomeUpselling && {
        text: t('start'),
        onClick: () => dispatch(Push(HomePaths.Home)),
    };
    const openSwitchProductModal = (): void => {
        dispatch(
            ShowDialog({
                body: <ChangeProductDialog />,
                title: t('changeproduct'),
                confirmLabel: t('changeproduct'),
                cancelLabel: t('cancel'),
                fullScreen: false,
                isHiddenManually: true,
                onClickConfirm: (): void => {
                    dispatch(ChangeProduct(billingPlanID, defaultTierID, eventLabel));
                },
            })
        );
    };

    return (
        <FeatureUpsellingModule
            feature={AvailableFeaturesUpselling.Marketing}
            isMobile={isMobile}
            breadcrumbs={breadcrumbs}
            onUpgradeButtonClick={openSwitchProductModal}
        />
    );
};
